import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { soccerPath } from '../utils/paths';

/** Redirect old bookmarked URLs (without /soccer) to the prefixed paths */
const LegacySoccerRedirect = () => {
  const { pathname, search } = useLocation();
  return <Navigate to={`${soccerPath(pathname)}${search}`} replace />;
};

export default LegacySoccerRedirect;
